require("bootstrap");
require("../layout");

require("@fancyapps/fancybox");
require("slick-carousel");

$(".btn-selector").on("click", function () {
    $(".btn-selector").removeClass("activo");
    $(this).addClass("activo");

    $(".imagenes-modelos .imagen").removeClass("activo");
    var planta = $(this).data("planta");
    $(planta).addClass("activo")

});

// $(".modelo-precios").find(".slide").slick({
//     arrows: true,
//     autoplay: true,
//     dots: false,
//     infinite: true,
//     slidesToScroll: 3,
//     autoplaySpeed: 1500,
//     slidesToShow: 3,
//     pauseOnHover: false,
//     vertical: true,
//     nextArrow:
//         '<a href="javascript:void(null);" class="slick-arrow slick-next">&rsaquo;</a>',
//     prevArrow:
//         '<a href="javascript:void(null);" class="slick-arrow slick-prev">&lsaquo;</a>',
// });